export default {"src":"/_next/static/media/project.d298e9a5.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};